module.exports = __webpack_public_path__ + "img/supplier_1.6ea0e242.png";